(function (app) {

    var VoucherModel = Backbone.Model.extend({
        idAttribute: 'ID',

        apply: function () {
            if (this.get('IsApplied') !== true) {
                app.checkout.applyVoucher(this);
            } else {
                app.checkout.removeVoucher(this);
            }
        }
    });

    var VouchersCollection = Backbone.Collection.extend({
        model: VoucherModel,

        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function (data) {
            this.update(data.Vouchers);
            this.trigger('update', this);
        }

        //update: function (models, opts) {
        //    Backbone.Collection.prototype.update.apply(this, arguments);
        //    this.trigger('update', this, opts);
        //}
    });

    var PromocodesModel = Backbone.Model.extend({
        idAttribute: 'ID'
    });

    var PromocodesCollection = Backbone.Collection.extend({
        model: PromocodesModel,

        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function (data) {
            this.update(data.PromoCodeList);
            this.trigger('update', this);
        }

        //update: function (models, opts) {
        //    Backbone.Collection.prototype.update.apply(this, arguments);
        //    this.trigger('update', this, opts);
        //}
    });

    app.models = _.extend({ vouchers: new VouchersCollection() }, app.models);
    app.models = _.extend({ promocodes: new PromocodesCollection() }, app.models);
})(app);

